import Vue from 'vue';

import { mountVue } from 'utils/vueContainer';

// All Vue components
import Pagetabs from 'components/Pagetabs';
import Newsletter from 'components/Newsletter';
import VueGlide from 'vue-glide-js';
import VueJsonp from 'vue-jsonp';
import VeeValidate, { Validator } from 'vee-validate';
import german from 'vee-validate/dist/locale/de';


Vue.use(VeeValidate);
Vue.use(VueJsonp);
Vue.use(VueGlide);

if (window.lang !== 'en' && window.lang.length === 2) {
    Validator.localize(window.lang);
}

Validator.localize('de', german);


// ------------------------------------------------------------------------
// Boot App
// ------------------------------------------------------------------------
require('boot');

// ------------------------------------------------------------------------
// Register Vue Components
// ------------------------------------------------------------------------
Vue.component('pagetabs', Pagetabs);
Vue.component('newsletter', Newsletter);

// ------------------------------------------------------------------------
// Mount Vue Instances (outside of Barba container)
// ------------------------------------------------------------------------
mountVue('.js-vueContainer', document);

// ------------------------------------------------------------------------
// Try to launch a vanilla component
// ------------------------------------------------------------------------
// require('components/pagetabs');

// ------------------------------------------------------------------------
// Triggers once the app has been launched
// ------------------------------------------------------------------------
document.addEventListener('AppReady', () => {
    document.documentElement.classList.remove('no-fouc');
});

// ------------------------------------------------------------------------
// Launch the app
// ------------------------------------------------------------------------
if (document.readyState === 'complete') {
    document.dispatchEvent(new CustomEvent('AppReady'));
} else {
    document.addEventListener('DOMContentLoaded', () => document.dispatchEvent(new CustomEvent('AppReady')));
}
